function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { AbstractPublisherTool } from '../../../../framework/publisher2/tools/AbstractPublisherTool';
var LogoTool = /*#__PURE__*/function (_AbstractPublisherToo) {
  function LogoTool() {
    var _this;
    _classCallCheck(this, LogoTool);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LogoTool, [].concat(args));
    _this.index = 1;
    _this.group = 'tools';
    _this.config = null;
    return _this;
  }
  _inherits(LogoTool, _AbstractPublisherToo);
  return _createClass(LogoTool, [{
    key: "init",
    value: function init(data) {
      var plugin = this.findPluginFromInitData(data);
      if (plugin) {
        var _plugin$config;
        this.storePluginConf(plugin.config);
        // when we enter publisher:
        // restore saved location for plugin that is not stopped nor started
        this.getPlugin().setLocation((_plugin$config = plugin.config) === null || _plugin$config === void 0 || (_plugin$config = _plugin$config.location) === null || _plugin$config === void 0 ? void 0 : _plugin$config.classes);
      }
    }
  }, {
    key: "getTool",
    value: function getTool() {
      return {
        id: 'Oskari.mapframework.bundle.mapmodule.plugin.LogoPlugin',
        title: 'LogoPlugin',
        config: this.state.pluginConfig || {}
      };
    }

    // not displayed on tool panels so user can't disable it
  }, {
    key: "isDisplayed",
    value: function isDisplayed() {
      return false;
    }
  }, {
    key: "getPlugin",
    value: function getPlugin() {
      // always use the instance on map, not a new copy
      return this.getMapmodule().getPluginInstances('LogoPlugin');
    }

    // always enabled, use the instance that is on map
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return true;
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this$getPlugin;
      // when we exit publisher:
      // move plugin back to bottom left if it was dragged during publisher
      (_this$getPlugin = this.getPlugin()) === null || _this$getPlugin === void 0 || _this$getPlugin.setLocation('bottom left');
    }

    /**
    * Get values.
    * @method getValues
    * @public
    *
    * @returns {Object} tool value object
    */
  }, {
    key: "getValues",
    value: function getValues() {
      var _plugin$getConfig;
      var plugin = this.getPlugin();
      if (!plugin) {
        return null;
      }
      return {
        configuration: {
          mapfull: {
            conf: {
              plugins: [{
                id: this.getTool().id,
                config: {
                  location: (_plugin$getConfig = plugin.getConfig()) === null || _plugin$getConfig === void 0 ? void 0 : _plugin$getConfig.location
                }
              }]
            }
          }
        }
      };
    }
  }]);
}(AbstractPublisherTool); // Attach protocol to make this discoverable by Oskari publisher
Oskari.clazz.defineES('Oskari.publisher.LogoTool', LogoTool, {
  protocol: ['Oskari.mapframework.publisher.Tool']
});
export { LogoTool };